export const CAPTION_PRESETS = {
  minimalist: {
    label: 'Minimalist',
    fontFamily: 'Arial, sans-serif',
    fontSize: 24,
    fontColor: '#FFFFFF',
    highlightColor: '#FFFF00',
    bgColor: 'transparent',
    outline: '1px #000000',
    position: 'bottom'
  },
  bold: {
    label: 'Bold',
    fontFamily: 'Impact, sans-serif',
    fontSize: 28,
    fontColor: '#FFFFFF',
    highlightColor: '#FF6600',
    bgColor: 'rgba(0,0,0,0.7)',
    outline: 'none',
    position: 'bottom'
  },
  white_bg: {
    label: 'White Background',
    fontFamily: 'Arial, sans-serif',
    fontSize: 24,
    fontColor: '#000000',
    highlightColor: '#000000',
    highlightBgColor: '#FFD600',
    bgColor: 'rgba(255,255,255,0.95)',
    outline: 'none',
    position: 'bottom'
  }
};

export const CAPTION_PRESET_KEYS = Object.keys(CAPTION_PRESETS);
export const DEFAULT_PRESET = 'minimalist';

export const HIGHLIGHT_MODES = {
  KARAOKE: 'karaoke',
  WORD_BY_WORD: 'word-by-word'
};

export const DEFAULT_HIGHLIGHT_MODE = HIGHLIGHT_MODES.KARAOKE;

export const WORDS_PER_DISPLAY = {
  ONE: 1,
  THREE: 3
};

export const DEFAULT_WORDS_PER_DISPLAY = WORDS_PER_DISPLAY.ONE;

export const CROP_PRESETS = [
  { value: '16:9', label: '16:9 (Landscape)' },
  { value: '9:16', label: '9:16 (Portrait/Reels)' },
  { value: '1:1', label: '1:1 (Square)' }
];

export const DEFAULT_CROP = '16:9';



// WEBPACK FOOTER //
// ./src/constants/caption-presets.js